export function hasSensitiveQuery(url: string): boolean {
  return !!url.match(/([&?])(p|openId|_n\d+_)=.+?(?=&|$)/)
}

export function removeSensitiveQuery(url: string): string {
  return url
    .replace(/([&?])(p|openId|_n\d+_)=.+?(?=&|$)/g, '$1')
    .replace(/&{2,}/g, '&')
    .replace(/&+$/, '')
    .replace(/\?&+/, '?')
}
